import classNames from 'classnames/bind';

import ApiResponseExample from '../../../GeneralComponents/ApiResponseExample';
import withComponentName from '../../../../decorators/withComponentName';

import strucuredDataImg from '../../../../assets/academia/pic-api-6-screen-1040.svg';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const StructuredDataSection = () => (
  <section className={cx('structured-data-section')}>
    <div className={Styles['section-wrapper']}>
      <div className={Styles['section-head']}>
        <h2 className={Styles['section-title']}>Build with Structured Data</h2>
        <p className={Styles.description}>
          Messy market data arranged with NLP and AI
        </p>
      </div>
      <div className={Styles['structed-data-main']}>
        <ApiResponseExample
          codeExample={{
            uuid: '82027298-e4cf-4c60-8c2a-7129bca41e31',
            publishTime: '2016-06-02T12:00:27.824Z',
            title: "Goldman Lowers iPhone Estimates, Cuts Apple's Price Target By 9 % -Apple Inc. (NASDAQ:AAPL) | Benzinga",
            description: 'Goldman Sachs’ Simona Jankowski mentioned that the estimates for Apple Inc. (NASDAQ: AAPL) had been reduced to reflect lower market growth and lower ...',
            assetTags: [
              'Apple',
              'AAPL US',
            ],
            searchTags: [
              'Apple',
            ],
            category: 'major_publication',
            url: 'http://www.benzinga.com/analyst-ratings/analyst-col-or/16/06/8060449/goldman-lowers-iphone-estimates-cuts-apples-price-target',
            cityfalconScore: '48',
            source: {
              name: 'www.benzinga.com',
              imageUrl: 'https://cityfalconproduction.blob.core.windows.net/autot-weetmedia/domains/logos/1308/original/PMttsGmx.png?1453405779',
            },
            duplicatesCount: '10',
            paywall: 'false',
            registrationRequired: 'false',
          }}
        />
        <div>
          <img src={strucuredDataImg} alt="cityfalcon structured data" />
        </div>
      </div>
    </div>
  </section>
);

export default withComponentName(StructuredDataSection);
